<script lang="ts">
	import Search from '@lucide/svelte/icons/search'
	import { Command as CommandPrimitive } from 'bits-ui'
	import { cn } from 'tailwind-variants'

	import * as InputGroup from '#lib/components/ui/input-group/index.js'

	let {
		ref = $bindable(null),
		class: className,
		value = $bindable(''),
		...restProps
	}: CommandPrimitive.InputProps = $props()
</script>

<div class="p-1 pb-0" data-slot="command-input-wrapper">
	<InputGroup.Root
		class="border-input/30 bg-input/30 h-8! rounded-lg! shadow-none! *:data-[slot=input-group-addon]:pl-2!"
	>
		<CommandPrimitive.Input
			class={cn(
				'w-full text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
				className
			)}
			data-slot="command-input"
			{value}
			{...restProps}
		>
			{#snippet child({ props })}
				<InputGroup.Input {...props} bind:value bind:ref />
			{/snippet}
		</CommandPrimitive.Input>

		<InputGroup.Addon>
			<Search class="size-4 shrink-0 opacity-50" />
		</InputGroup.Addon>
	</InputGroup.Root>
</div>
